var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 8.83398C4.08203 8.83398 3.33203 9.58398 3.33203 10.5007C3.33203 11.4173 4.08203 12.1673 4.9987 12.1673C5.91536 12.1673 6.66536 11.4173 6.66536 10.5007C6.66536 9.58398 5.91536 8.83398 4.9987 8.83398ZM14.9987 8.83398C14.082 8.83398 13.332 9.58398 13.332 10.5007C13.332 11.4173 14.082 12.1673 14.9987 12.1673C15.9154 12.1673 16.6654 11.4173 16.6654 10.5007C16.6654 9.58398 15.9154 8.83398 14.9987 8.83398ZM9.9987 8.83398C9.08203 8.83398 8.33203 9.58398 8.33203 10.5007C8.33203 11.4173 9.08203 12.1673 9.9987 12.1673C10.9154 12.1673 11.6654 11.4173 11.6654 10.5007C11.6654 9.58398 10.9154 8.83398 9.9987 8.83398Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.142402ff.svg";
export { ForwardRef as ReactComponent };